// Genera un UUIDv7 (ordenado por tiempo) en el navegador.
//
// Cada movimiento encolado offline lleva uno: es su clave de idempotencia.
// El servidor rechaza un movimiento con una clave ya vista, de modo que
// reenviar la cola al reconectar nunca duplica existencias.
export function uuidv7() {
  const ts = Date.now();
  const b = new Uint8Array(16);
  crypto.getRandomValues(b);

  // 48 bits de milisegundos al frente.
  b[0] = Math.floor(ts / 2 ** 40) & 0xff;
  b[1] = Math.floor(ts / 2 ** 32) & 0xff;
  b[2] = Math.floor(ts / 2 ** 24) & 0xff;
  b[3] = Math.floor(ts / 2 ** 16) & 0xff;
  b[4] = Math.floor(ts / 2 ** 8) & 0xff;
  b[5] = ts & 0xff;

  b[6] = (b[6] & 0x0f) | 0x70; // version 7
  b[8] = (b[8] & 0x3f) | 0x80; // variante

  const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
